import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout1 } from './Layout1';

// Professional UX: Always scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="page-fade-in min-h-screen flex flex-col">
        <Layout1>
          <AppRoutes />
        </Layout1>
      </div>
    </BrowserRouter>
  );
}
export default App;

